"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mfe_common_stitcher_lib_1 = require("mfe-common-stitcher-lib");
const history_1 = require("history");
//import { processMultiLanguageProps, checkAuthInterceptor } from './index.logic'
const index_logic_1 = require("./index.logic");
const render_1 = require("./render");
const config_1 = require("./config");
const mfe_1 = __importDefault(require("./data-manager/mfe"));
const stitcherLogin2faTrigger_1 = __importDefault(require("./common/stitcherLogin2faTrigger"));
const stitcherGetLanguageFileTrigger_1 = require("./common/stitcherGetLanguageFileTrigger");
const globalState_1 = require("./store/globalState");
const update_language_1 = __importDefault(require("./common/update-language"));
const appConfig_1 = require("./common/utils/appConfig");
const uuid_1 = require("uuid");
const global_1 = require("./store/global");
const server_1 = require("./mock/mirage/server");
const moment_1 = __importDefault(require("moment"));
const mfe_common_common_utils_lib_1 = require("mfe-common-common-utils-lib");
const dynatrace_1 = require("./utils/dynatrace");
const constants_1 = require("./features/transaction-signing/constants");
// init loader
const loader = (loading) => (0, render_1.loadingRender)({ loading });
const history = (0, history_1.createBrowserHistory)();
let intervalId;
let autoLogOffTimer;
let loginDateTime = new Date().getTime() / 1000;
let openCountDownDialog = false;
const appjson = 'application/json';
const menuRepo = 'mfe-common-bfo-menu';
let fullRegisterConfig = {};
const triggerAutoLogout = false;
//const resetTimer = props.getGlobalState().sessionData.resetTimer ? props.getGlobalState().sessionData.resetTimer : false
function autoLogoffDeactivation(getGlobalState, setGlobalState) {
    return __awaiter(this, void 0, void 0, function* () {
        // Calling the get user status API
        const registerConfig = fullRegisterConfig;
        const country = registerConfig.global.country;
        const menuConfig = registerConfig.subApps.find(item => item.name === 'mfe-common-bfo-banner');
        const refreshTokenURL = menuConfig.props.baseUrl + menuConfig.props.refreshToken;
        const refreshToken = getGlobalState().sessionData.refreshToken;
        const opaqueToken = getGlobalState().sessionData.opaqueToken;
        const id = getGlobalState().account.userId;
        // 8 minutes
        const tokenExpirySeconds = 480;
        const parameter = {
            id: id,
            token: opaqueToken,
            refresh_token: refreshToken,
            tokenExpirySeconds: tokenExpirySeconds
        };
        const headers = {
            'Content-Type': appjson,
            'x-source-country': country,
            'x-correlation-id': (0, uuid_1.v4)(),
            'x-unique-session-id': window.sessionStorage.getItem('userUniqueSessionId'),
            'x-source-date-time': datTimeConverter(new Date()),
            'x-source-id': 'DTB',
            'x-acc-op': opaqueToken
        };
        fetch(refreshTokenURL, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(parameter)
        })
            .then(res => {
            if (!res.ok) {
                if (res.status === 401) {
                    clearIntervalAndTimeout(getGlobalState);
                    const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }) });
                    setGlobalState(globalState);
                    sessionExpired(registerConfig, getGlobalState, setGlobalState);
                }
            }
            return res.json();
        })
            .then(data => {
            const globalState = getGlobalState();
            if (data.status === 'EXPIRED') {
                globalState.account.deactivated = true;
            }
            else if (data.status === 'CONCURRENT_LOGIN') {
                globalState.account.isActiveSession = true;
            }
            else if (data.status === 'SUCCESS') {
                globalState.sessionData.opaqueToken = data.opaqueToken;
                globalState.sessionData.refreshToken = data.refreshToken;
            }
            setGlobalState(globalState);
            const axiosHeader = Object.assign(Object.assign({}, (0, mfe_common_common_utils_lib_1.getAxiosHeader)()), { 'x-acc-op': data.opaqueToken, 'x-ref-op': data.refreshToken });
            (0, mfe_common_common_utils_lib_1.setAxiosHeader)(axiosHeader);
            // const loginContext = JSON.parse(window.sessionStorage.getItem('LoginContext'))
            // sessionStorage.setItem('LoginContext', JSON.stringify({ ...loginContext, 'x-acc-op': data.opaqueToken, 'x-ref-op': data.refreshToken }))
            // window.sessionStorage.setItem('accessToken', data.opaqueToken)
            // window.sessionStorage.setItem('refreshToken', data.refreshToken)
            // window.sessionStorage.setItem('x_acc_op', data.opaqueToken)
            // window.sessionStorage.setItem('x_ref_op', data.refreshToken)
        })
            .catch(error => {
            clearIntervalAndTimeout(getGlobalState);
            const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }) });
            setGlobalState(globalState);
            sessionExpired(registerConfig, getGlobalState, setGlobalState);
        });
    });
}
function idleSessionTimeout(refreshSession, getGlobalState, setGlobalState) {
    return __awaiter(this, void 0, void 0, function* () {
        const registerConfig = fullRegisterConfig;
        toggleActiveSessionPopUp(getGlobalState, setGlobalState);
        if (refreshSession === 'Y') {
            const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { resetTimer: false, firstTimeRun: true, logout: false }) });
            setGlobalState(globalState);
        }
        const idleSessionTimeoutGracePeriodTimeout = getGlobalState().sessionData.Idle_Session_Timeout_Grace_Period;
        const idleTimeout = getGlobalState().sessionData.Idle_Session_Time_Out;
        const calculationIdleSession = idleTimeout / 60 / 1000 - idleSessionTimeoutGracePeriodTimeout / 60 / 1000;
        const gracePeriodTimer = calculationIdleSession * 60;
        const idleTimeOutTimer = idleTimeout / 1000;
        loginDateTime = new Date().getTime() / 1000;
        if (refreshSession === 'Y') {
            intervalId = setInterval(() => {
                if (getGlobalState().sessionData.resetTimer === true) {
                    loginDateTime = new Date().getTime() / 1000;
                    openCountDownDialog = false;
                    const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { resetTimer: false }) });
                    setGlobalState(globalState);
                }
                if (getGlobalState().sessionData.firstTimeRun === true) {
                    loginDateTime = new Date().getTime() / 1000;
                    openCountDownDialog = false;
                    const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { firstTimeRun: false }) });
                    setGlobalState(globalState);
                }
                if (getGlobalState().sessionData.logout === true) {
                    openCountDownDialog = false;
                    loginDateTime = new Date().getTime() / 1000;
                    const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { logout: true }) });
                    setGlobalState(globalState);
                    sessionExpired(registerConfig, getGlobalState, setGlobalState);
                    clearInterval(intervalId);
                }
                const currentDateTime = new Date().getTime() / 1000;
                const differentTime = parseInt(currentDateTime.toString()) - parseInt(loginDateTime.toString());
                if (differentTime >= gracePeriodTimer) {
                    openCountDownDialog = true;
                    (0, render_1.sessionTimeoutDialog1)({
                        sessionTimeoutDialog: true,
                        date: new Date(),
                        registerConfig: registerConfig,
                        idleSessionTimeout: idleSessionTimeout,
                        sessionExpired: sessionExpired,
                        getGlobalState: getGlobalState,
                        setGlobalState: setGlobalState,
                        idleSessionTimeoutGracePeriodTimeout: idleTimeOutTimer - differentTime
                    });
                }
                if (differentTime >= idleTimeOutTimer) {
                    const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { logout: true }) });
                    setGlobalState(globalState);
                    (0, render_1.sessionTimeoutDialog1)({
                        sessionTimeoutDialog: false,
                        date: new Date(),
                        registerConfig: registerConfig,
                        idleSessionTimeout: idleSessionTimeout,
                        sessionExpired: sessionExpired,
                        getGlobalState: getGlobalState,
                        setGlobalState: setGlobalState,
                        idleSessionTimeoutGracePeriodTimeout: 0
                    });
                    sessionExpired(registerConfig, getGlobalState, setGlobalState);
                    clearInterval(intervalId);
                }
            }, 1000);
        }
        else {
            clearTimeout(intervalId);
        }
        togglePasswordExpireSoon(getGlobalState, registerConfig);
    });
}
function tokenExpired(getGlobalState, setGlobalState) {
    return __awaiter(this, void 0, void 0, function* () {
        const registerConfig = fullRegisterConfig;
        const globalState = Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }) });
        setGlobalState(globalState);
        sessionExpired(registerConfig, getGlobalState, setGlobalState);
    });
}
function togglePasswordExpireSoon(getGlobalState, registerConfig) {
    var _a;
    const menuConfig = registerConfig.subApps.find(item => item.name === menuRepo);
    const userSettingPage = menuConfig.props.userSetting;
    const LoginContext = ((_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.account) || {};
    if (LoginContext === null || LoginContext === void 0 ? void 0 : LoginContext.isPasswordExpireSoon) {
        (0, render_1.passwordExpireSoonDialog)(getGlobalState, userSettingPage);
    }
}
function sessionExpired(registerConfig, getGlobalState, setGlobalState, isAutoLogout) {
    var _a;
    const country = (_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.account.country;
    const menuConfig = registerConfig.subApps.find(item => item.name === menuRepo);
    const authenticationUrl = menuConfig.props.baseUrl + menuConfig.props.authenticationLogoutUrl;
    logout(country, authenticationUrl, menuConfig, getGlobalState, setGlobalState, isAutoLogout);
}
function sessionExpiredAndRevokeUser(registerConfig, getGlobalState, setGlobalState) {
    var _a;
    const country = (_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.account.country;
    const menuConfig = registerConfig.subApps.find(item => item.name === menuRepo);
    const authenticationUrl = menuConfig.props.baseUrl + menuConfig.props.revokeUserLogoutUrl;
    logout(country, authenticationUrl, menuConfig, getGlobalState, setGlobalState);
}
function datTimeConverter(dateTime) {
    return `${(0, moment_1.default)(dateTime).format('YYYY-MM-DD HH:mm:ss.SSS')}`;
}
function exitUser(registerConfig, getGlobalState, setGlobalState) {
    var _a, _b, _c;
    const country = (_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.account.country;
    const menuConfig = registerConfig.subApps.find(item => item.name === menuRepo);
    const LoginContext = (_b = getGlobalState()) === null || _b === void 0 ? void 0 : _b.sessionData;
    const LogoutDetail = (_c = getGlobalState()) === null || _c === void 0 ? void 0 : _c.Logout;
    const currentLoginDateTime = (LogoutDetail === null || LogoutDetail === void 0 ? void 0 : LogoutDetail.loginTime) ? LogoutDetail.loginTime : LoginContext.current_login_dateTime;
    const logoutPage = menuConfig.props.logoutPage;
    const globalState = {
        // ...getGlobalState(),
        sessionData: {
            // ...getGlobalState().sessionData,
            last_login_dateTime: currentLoginDateTime,
            logout_dateTime: (LogoutDetail === null || LogoutDetail === void 0 ? void 0 : LogoutDetail.logoutTime) ? LogoutDetail === null || LogoutDetail === void 0 ? void 0 : LogoutDetail.logoutTime : Date.now(),
            'session-type': 'success_logout',
            timeZone: timeZoneDisplay(country)
        },
        account: {
            // ...getGlobalState().account,
            isLogout: true
        }
    };
    setGlobalState(globalState);
    const element = document.getElementById('app_content');
    element.style.display = 'none';
    const userUniqueSessionId = window.sessionStorage.getItem('userUniqueSessionId');
    window.sessionStorage.clear();
    (0, mfe_common_common_utils_lib_1.setAxiosHeader)({});
    window.sessionStorage.setItem('userUniqueSessionId', userUniqueSessionId);
    history.push(logoutPage);
}
function timeZoneDisplay(countryParam) {
    switch (countryParam) {
        case 'MY':
            return 'MYT';
        case 'SG':
            return 'SGT';
        case 'KH':
            return 'KHT';
        default:
            return 'MYT';
    }
}
function logout(country, authenticationUrl, menuConfig, getGlobalState, setGlobalState, isAutoLogout = false) {
    var _a, _b, _c, _d;
    const logoutPage = menuConfig.props.logoutPage;
    const AccountContext = ((_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.account) || {};
    const parseLoginContext = JSON.parse(window.sessionStorage.getItem('LoginContext') || '{}');
    const id = (_b = AccountContext.userId) !== null && _b !== void 0 ? _b : window.sessionStorage.getItem('userId');
    const LoginContext = (_c = getGlobalState()) === null || _c === void 0 ? void 0 : _c.sessionData;
    const currentLoginDateTime = LoginContext.current_login_dateTime;
    const opaqueToken = (_d = LoginContext.opaqueToken) !== null && _d !== void 0 ? _d : window.sessionStorage.getItem('logoutOpaqueToken');
    const sessionType = (LoginContext === null || LoginContext === void 0 ? void 0 : LoginContext.sessionType) ? LoginContext === null || LoginContext === void 0 ? void 0 : LoginContext.sessionType : 'session_expired';
    console.log('logout LoginContext', LoginContext);
    console.log('logout parseLoginContext', parseLoginContext);
    console.log('logout logoutOpaqueToken', window.sessionStorage.getItem('logoutOpaqueToken'));
    const parameter = {
        login_id: id,
        opaqueToken: opaqueToken
    };
    const headers = {
        'Content-Type': appjson,
        'x-source-country': country,
        'x-business-type': 'Corporate',
        'x-correlation-id': (0, uuid_1.v4)(),
        'x-unique-session-id': window.sessionStorage.getItem('userUniqueSessionId'),
        'x-source-date-time': datTimeConverter(new Date()),
        'x-source-id': 'DTB',
        'x-acc-op': opaqueToken !== null && opaqueToken !== void 0 ? opaqueToken : ''
    };
    fetch(authenticationUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(parameter)
    })
        .then(res => {
        return res.json();
    })
        .then(data => {
        if (data.status === 'SUCCESS') {
            clearIntervalAndTimeout(getGlobalState);
            openCountDownDialog = false;
            const globalState = {
                // ...getGlobalState(),
                sessionData: {
                    // ...getGlobalState().sessionData,
                    last_login_dateTime: currentLoginDateTime,
                    logout_dateTime: data.logoutTime,
                    sessionType: isAutoLogout ? 'auto_logout' : sessionType,
                    timeZone: data.timeZoneShort
                },
                account: {
                    // ...getGlobalState().account,
                    isLogout: true
                }
            };
            setGlobalState(globalState);
            (0, render_1.closeAllPopUp)();
            const element = document.getElementById('app_content');
            element.style.display = 'none';
            const userUniqueSessionId = window.sessionStorage.getItem('userUniqueSessionId');
            window.sessionStorage.clear();
            (0, mfe_common_common_utils_lib_1.setAxiosHeader)({});
            window.sessionStorage.setItem('userUniqueSessionId', userUniqueSessionId);
            history.push(logoutPage);
        }
    })
        .catch(error => {
        clearIntervalAndTimeout(getGlobalState);
        const globalState = {
            // ...getGlobalState(),
            sessionData: {
                // ...getGlobalState().sessionData,
                last_login_dateTime: currentLoginDateTime,
                logout_dateTime: Date.now(),
                'session-type': isAutoLogout ? 'auto_logout' : 'success_logout',
                timeZone: timeZoneDisplay(country)
            },
            account: {
                // ...getGlobalState().account,
                isLogout: true
            }
        };
        setGlobalState(globalState);
        (0, render_1.closeAllPopUp)();
        const element = document.getElementById('app_content');
        element.style.display = 'none';
        const userUniqueSessionId = window.sessionStorage.getItem('userUniqueSessionId');
        window.sessionStorage.clear();
        (0, mfe_common_common_utils_lib_1.setAxiosHeader)({});
        window.sessionStorage.setItem('userUniqueSessionId', userUniqueSessionId);
        history.push(logoutPage);
    });
}
function clearIntervalAndTimeout(getGlobalState) {
    var _a;
    const loginContext = ((_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.sessionData) || {};
    // To Confirm
    const tokenInterval = loginContext['token-interval'];
    const tokenTimeout = loginContext['token-timeout'];
    // Used
    const IdleSessionTimeoutGracePeriod = loginContext['idle-grace-period-timeout'];
    const sessionTimeout = loginContext['idle-timeout'];
    window.clearInterval(tokenInterval);
    window.clearTimeout(tokenTimeout);
    window.clearTimeout(IdleSessionTimeoutGracePeriod);
    window.clearTimeout(sessionTimeout);
    clearInterval(intervalId);
    clearInterval(autoLogOffTimer);
}
function toggleActiveSessionPopUp(getGlobalState, setGlobalState) {
    var _a;
    const LoginContext = ((_a = getGlobalState()) === null || _a === void 0 ? void 0 : _a.sessionData) || {};
    if ((LoginContext === null || LoginContext === void 0 ? void 0 : LoginContext.isActiveSession) === true) {
        (0, render_1.activeSessionDialog)({
            _activeSessionDialog: true,
            date: new Date(),
            getGlobalState: getGlobalState,
            setGlobalState: setGlobalState
        });
        const newLoginContext = JSON.stringify(Object.assign(Object.assign({}, LoginContext), { isMultipleBrowserLogin: false }));
        setGlobalState({ LoginContext: newLoginContext });
    }
}
function handleR4Return() {
    return __awaiter(this, void 0, void 0, function* () {
        const parseBool = (v) => v === 'true';
        const sanitizeErrorCode = (v) => {
            if (!v) {
                return '9999';
            }
            return /^[A-Za-z0-9]{1,15}$/.test(v) ? v : '9999';
        };
        const params = new URLSearchParams(location.search);
        const isReturnSuccess = parseBool(params.get('isReturnSuccess'));
        const errorCode = sanitizeErrorCode(params.get('errorCode'));
        const baseUrl = window.location.origin;
        let redirectUrl = `${baseUrl}/digital/web/gl/bfo/login?isReturnSuccess=${encodeURIComponent(String(isReturnSuccess))}`;
        if (!isReturnSuccess) {
            redirectUrl += `&errorCode=${encodeURIComponent(errorCode)}`;
        }
        try {
            const u = new URL(redirectUrl);
            if (!/^https?:$/.test(u.protocol)) {
                throw new Error('Bad protocol');
            }
        }
        catch (_a) {
            redirectUrl = '/sso/error';
        }
        window.location.href = redirectUrl;
    });
}
function setConfigForR4() {
    return __awaiter(this, void 0, void 0, function* () {
        const registerConfig = yield mfe_1.default.getRegisterMFEList();
        console.log('setConfigForR4 registerConfig', registerConfig);
        const { multiLanguageSubUrl, publicPath, interwovenServer, useMockApi } = registerConfig.stitcher;
        const { country, bannerMultiLanguageSubUrl, footerMultiLanguageSubUrl, loginMultiLanguageSubUrl, msUiTokenManagement } = registerConfig.global;
        (0, appConfig_1.setConfig)({
            multiLanguageSubUrl,
            publicPath,
            country,
            serverDatetime: new Date().toISOString(),
            useMockApi,
            interwovenServer,
            bannerMultiLanguageSubUrl,
            loginMultiLanguageSubUrl,
            footerMultiLanguageSubUrl,
            msUiTokenManagement
        });
    });
}
;
(() => __awaiter(void 0, void 0, void 0, function* () {
    if (constants_1.isR4) {
        console.log('isR4');
        yield setConfigForR4();
        window.addEventListener('message', (event) => {
            var _a, _b, _c, _d, _e;
            console.log('MESSAGE RECEIVED', event);
            const temp = true;
            //NOSONAR
            if (!temp && event.origin !== window.location.origin) {
                return;
            }
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === constants_1.R4_MESSAGE_TYPE.INIT_TAC) {
                console.log('INIT_TAC RECEIVED', event);
                const { token, authId } = (_b = event.data) === null || _b === void 0 ? void 0 : _b.payload;
                console.log('token', token);
                console.log('authId', authId);
                window.sessionStorage.setItem('x_acc_op', token);
                (0, render_1.TransactionSigningRender)({
                    isHidden: false,
                    paramProps: {
                        authorizationId: authId
                    },
                    onSuccess: () => { },
                    onFailure: () => { },
                    onClose: () => {
                        window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.TAC_CANCEL }, constants_1.parentOrigin);
                    },
                    onCancel: () => { }
                });
            }
            if (((_c = event.data) === null || _c === void 0 ? void 0 : _c.type) === constants_1.R4_MESSAGE_TYPE.UPDATE_TOKEN) {
                console.log('UPDATE_TOKEN RECEIVED', event);
                window.sessionStorage.setItem('x_acc_op', (_e = (_d = event.data) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.token);
                return;
            }
        });
        window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.IFRAME_READY }, constants_1.parentOrigin);
        return;
    }
    const isOAuthReturn = window.location.pathname === '/v2/sso/oauth2/v2.0/return';
    if (isOAuthReturn) {
        handleR4Return();
    }
    console.log('window.location.pathname', window.location.pathname);
    window.addEventListener('click', function () {
        if (openCountDownDialog === false) {
            loginDateTime = new Date().getTime() / 1000;
        }
        //if (stitcherService.getGlobalState().account.isLogout === false) {
        //	if (stitcherService.getGlobalState().account.deactivated === true || stitcherService.getGlobalState().account.isActiveSession === true) {
        //		const globalState = {
        //			...stitcherService.getGlobalState(),
        //			sessionData: {
        //				...stitcherService.getGlobalState(),
        //				sessionType: 'ACTIVE_SESSION'
        //			}
        //		}
        //		stitcherService.setGlobalState(globalState)
        //		sessionExpired(registerConfig, stitcherService.getGlobalState, stitcherService.setGlobalState)
        //	}
        //}
    });
    window.addEventListener('input', function () {
        if (openCountDownDialog === false) {
            loginDateTime = new Date().getTime() / 1000;
        }
    });
    window.addEventListener('mousedown', function () {
        if (openCountDownDialog === false) {
            loginDateTime = new Date().getTime() / 1000;
        }
    });
    window.addEventListener('message', e => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if (typeof (e === null || e === void 0 ? void 0 : e.origin) == 'string') {
            if (((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.routeType) === 'ShowLoading') {
                if ((_c = (_b = stitcherService === null || stitcherService === void 0 ? void 0 : stitcherService.getGlobalState()) === null || _b === void 0 ? void 0 : _b.sessionData) === null || _c === void 0 ? void 0 : _c.x_acc_op) {
                    return loader(true);
                }
                return null;
            }
            if (((_d = e === null || e === void 0 ? void 0 : e.data) === null || _d === void 0 ? void 0 : _d.routeType) === 'CloseLoading') {
                return loader(false);
            }
            if (((_e = e === null || e === void 0 ? void 0 : e.data) === null || _e === void 0 ? void 0 : _e.routeType) === 'tokenExpired') {
                const globalState = Object.assign(Object.assign({}, stitcherService.getGlobalState()), { sessionData: Object.assign(Object.assign({}, stitcherService.getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }) });
                stitcherService.setGlobalState(globalState);
                return sessionExpired(fullRegisterConfig, stitcherService.getGlobalState, stitcherService.setGlobalState);
            }
            if (((_f = e === null || e === void 0 ? void 0 : e.data) === null || _f === void 0 ? void 0 : _f.routeType) === 'revokeUser') {
                const globalState = Object.assign(Object.assign({}, stitcherService.getGlobalState()), { sessionData: Object.assign(Object.assign({}, stitcherService.getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }) });
                stitcherService.setGlobalState(globalState);
                return sessionExpiredAndRevokeUser(fullRegisterConfig, stitcherService.getGlobalState, stitcherService.setGlobalState);
            }
            if (((_g = e === null || e === void 0 ? void 0 : e.data) === null || _g === void 0 ? void 0 : _g.routeType) === 'forceExitUser') {
                const loginTime = (_j = (_h = e === null || e === void 0 ? void 0 : e.data) === null || _h === void 0 ? void 0 : _h.logoutDetail) === null || _j === void 0 ? void 0 : _j.loginTime;
                const logoutTime = (_l = (_k = e === null || e === void 0 ? void 0 : e.data) === null || _k === void 0 ? void 0 : _k.logoutDetail) === null || _l === void 0 ? void 0 : _l.logoutTime;
                const globalState = Object.assign(Object.assign({}, stitcherService.getGlobalState()), { sessionData: Object.assign(Object.assign({}, stitcherService.getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }), Logout: {
                        loginTime: loginTime,
                        logoutTime: logoutTime
                    } });
                stitcherService.setGlobalState(globalState);
                exitUser(fullRegisterConfig, stitcherService.getGlobalState, stitcherService.setGlobalState);
            }
            if (((_m = e === null || e === void 0 ? void 0 : e.data) === null || _m === void 0 ? void 0 : _m.routeType) === 'changePasswordExitUser') {
                const coolingStartTime = (_p = (_o = e === null || e === void 0 ? void 0 : e.data) === null || _o === void 0 ? void 0 : _o.logoutDetail) === null || _p === void 0 ? void 0 : _p.coolingStartTime;
                const coolingEndTime = (_r = (_q = e === null || e === void 0 ? void 0 : e.data) === null || _q === void 0 ? void 0 : _q.logoutDetail) === null || _r === void 0 ? void 0 : _r.coolingEndTime;
                const coolingOffPeriodHour = (_t = (_s = e === null || e === void 0 ? void 0 : e.data) === null || _s === void 0 ? void 0 : _s.logoutDetail) === null || _t === void 0 ? void 0 : _t.coolingOffPeriodHour;
                const globalState = Object.assign(Object.assign({}, stitcherService.getGlobalState()), { sessionData: Object.assign(Object.assign({}, stitcherService.getGlobalState().sessionData), { sessionType: 'ACTIVE_SESSION' }), Logout: {
                        coolingStartTime: coolingStartTime,
                        coolingEndTime: coolingEndTime,
                        isPostLoginChangePswd: true,
                        coolingOffPeriodHour: coolingOffPeriodHour
                    } });
                stitcherService.setGlobalState(globalState);
                exitUser(fullRegisterConfig, stitcherService.getGlobalState, stitcherService.setGlobalState);
            }
            return null;
        }
        return null;
    });
    /**
     * Step1 get MFE Config
     */
    const registerConfig = yield mfe_1.default.getRegisterMFEList();
    fullRegisterConfig = registerConfig;
    if (registerConfig.global.enableLog === '0') {
        console.log = () => { };
        console.warn = () => { };
        console.error = () => { };
        console.debug = () => { };
        console.info = () => { };
        console.trace = () => { };
        console.group = () => { };
        console.groupCollapsed = () => { };
    }
    const setUserUniqueSessionId = () => {
        const userUniqueSessionId = window.sessionStorage.getItem('userUniqueSessionId');
        if (!userUniqueSessionId) {
            window.sessionStorage.setItem('userUniqueSessionId', (0, uuid_1.v4)());
        }
    };
    function init() {
        return __awaiter(this, void 0, void 0, function* () {
            const fetchSubApps = () => __awaiter(this, void 0, void 0, function* () {
                if (registerConfig === null || registerConfig === void 0 ? void 0 : registerConfig.miniStitcherGroups) {
                    const promises = registerConfig.miniStitcherGroups.map((applicationGroup) => __awaiter(this, void 0, void 0, function* () {
                        const datetime = new Date().getTime();
                        try {
                            const applicationConfig = yield (yield fetch(`${applicationGroup.applicationConfigPath}?t=${datetime}`)).json();
                            console.log('applicationConfig', applicationConfig);
                            console.log('applicationConfig.applications', applicationConfig.applications);
                            if (applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.subApps) {
                                applicationConfig.subApps.forEach(application => {
                                    application.entry =
                                        application.entry && !application.entry.includes(applicationGroup.domainPath)
                                            ? `${applicationGroup.domainPath}${application.entry}`
                                            : application.entry;
                                    /** every mini stitcher should has its own activeRule prefix
                                     * e.g.
                                     * main-stitcher: /digital/web/hk/bfo/main/MFE_ACTIVE_RULE
                                     * tools-stitcher: /digital/web/hk/bfo/tools/MFE_ACTIVE_RULE
                                     */
                                    application.activeRule = (() => {
                                        if (applicationGroup.miniPublicPath && !Array.isArray(application.activeRule)) {
                                            return `${applicationGroup.miniPublicPath}${application.activeRule}`;
                                        }
                                        const stitcherPublicPath = registerConfig.stitcher.publicPath;
                                        return Array.isArray(application.activeRule) ? application.activeRule.map(rule => `${stitcherPublicPath}${rule}`) : application.activeRule;
                                    })();
                                    console.log(' application.entry', application.entry);
                                });
                            }
                            return Promise.resolve(applicationConfig.subApps || []);
                        }
                        catch (e) {
                            console.warn(`Cant fetch ${applicationGroup.domainPath} at ${applicationGroup.applicationConfigPath}`);
                        }
                        return null; //sqfix
                    }));
                    const result = yield Promise.all(promises);
                    console.log('result', result);
                    const subApps = result.flat().filter(function (element) {
                        return element !== undefined;
                    });
                    console.log('subApps', subApps);
                    return Promise.resolve(subApps);
                }
                return null; //sqfix
            });
            const applications = (yield fetchSubApps()) || [];
            // main stitcher config
            registerConfig.subApps = registerConfig.subApps.map(item => {
                if (registerConfig.stitcher.mainPublicPath) {
                    item.activeRule = registerConfig.stitcher.mainPublicPath + item.activeRule;
                }
                return item;
            });
            // mini stitcher config
            registerConfig.subApps = registerConfig.subApps.concat(applications);
            // set user session id
            setUserUniqueSessionId();
            console.log('registerConfig.subApps', registerConfig.subApps);
        });
    }
    yield init();
    /**
     * Step2 prepare your configuration / API
     */
    const { multiLanguageSubUrl, publicPath, interwovenServer, useMockApi } = registerConfig.stitcher;
    const language = registerConfig.stitcher.language;
    const { country, bannerMultiLanguageSubUrl, footerMultiLanguageSubUrl, loginMultiLanguageSubUrl, msUiTokenManagement } = registerConfig.global;
    (0, appConfig_1.setConfig)({
        multiLanguageSubUrl,
        publicPath,
        country,
        serverDatetime: new Date().toISOString(),
        useMockApi,
        interwovenServer,
        bannerMultiLanguageSubUrl,
        loginMultiLanguageSubUrl,
        footerMultiLanguageSubUrl,
        msUiTokenManagement
    });
    // REMOVE THIS AFTER TEST
    // window.sessionStorage.setItem(
    // 	'accessToken',
    // 	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IiIsImFtciI6WyJwd2QiLCJzb2Z0X3Rva2VuIl0sImlhbCI6IjJGQSIsImN1c3RvbSI6ey'
    //    + 'JvcmdfbmFtZSI6IkRVTU1ZX09SRyIsIm9yZ19pZCI6IkRVTU1ZX09SRyIsInVlbiI6IkExMjM0MzIxMzIxMzIxIiwiYnVzaW5lc3Nfc2VnbWVudCI6IkIiL'
    //    + 'CJjaWZfbm8iOiIxMDI5MzAiLCJhY2Nlc3NfY29kZSI6IjQ0YTEzNjZmLWY4MzEtNTU1OS1mMjI3LWYwOWU3ZjU4OWQzYyIsImxhbl9pZCI6IiIsImxlZ2Fs'
    //    + 'X2lkIjoiTUFLRVIxIiwibGVnYWxfbmFtZSI6Ik1BS0VSMSIsInNlY3VyaXR5Q2hlY2siOnRydWUsImRldmljZV9pbmZvIjp7ImZwdCI6IiIsInRpZCI6IiI'
    //    + 'sInRzbiI6IiJ9LCJzZXNzaW9uX2lkIjoiNGY2YjMyOTktY2I2MS00OWFkLThjMzItMWQ0ZGViM2FmMjViIiwibG9naW5faWQiOiJNQUtFUjEiLCJ1c2VyX2'
    //    + 'lkIjoiNDRhMTM2NmYtZjgzMS01NTU5LWYyMjctZjA5ZTdmNTg5ZDNjIiwicmVzcG9uc2VfdHlwZSI6IlJlc291cmNlX093bmVyIiwiY2xpZW50X2lkIjoiQ'
    //    + '0xJRU5UX0lEIiwidHJhbnNhY3Rpb25fY29udGV4dF9pZCI6ImVkNGZmMjE2LWRmMWQtNGUzYS1iZjg2LThjMDM1MDI2ODEyYSJ9LCJzdWJfdHlwZSI6IkJW'
    //    + 'X0FDQ0VTU19DT0RFIiwic3ViIjoiNDRhMTM2NmYtZjgzMS01NTU5LWYyMjctZjA5ZTdmNTg5ZDNjIn0.QJgzO3LskvF_TMxeXzq-qfHyqineX6fp9lu488P'
    //    + 'BGN0'
    // )
    // if it's in iframe, run this code
    // if (isIFrame()) {
    // 	const SET_READY = 'SET_READY'
    // 	const getAction = actionType => ({ actionType })
    // 	const postReactReady = () => {
    // 		const action = getAction(SET_READY)
    // 		window.parent.postMessage(action, '*')
    // 	}
    // 	const onMessage = event => {
    // 		try {
    // 			const parsedData = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
    // 			if (parsedData.reactAccessToken) {
    // 				window.sessionStorage.setItem('accessToken', parsedData.reactAccessToken)
    // 				window.sessionStorage.setItem('refreshToken', parsedData.reactRefreshToken)
    // 			}
    // 			if (parsedData.x_acc_op) {
    // 				window.sessionStorage.setItem('accessToken', parsedData.x_acc_op)
    // 				window.sessionStorage.setItem('refreshToken', parsedData.x_ref_op)
    // 			}
    // 			if (parsedData.localeCode) {
    // 				window.sessionStorage.setItem('localeCode', parsedData.localeCode)
    // 			}
    // 		} catch (e) {
    // 			console.debug(e)
    // 		}
    // 	}
    // 	window.addEventListener('message', onMessage)
    // 	postReactReady()
    // }
    /**
     * Step3 init stitcher service
     */
    const stitcherService = new mfe_common_stitcher_lib_1.StitcherAppService({
        globalStateProps: Object.assign(Object.assign({}, (0, globalState_1.initGlobalState)()), { app: 'init', forgotpasswordCallback: { isHidden: true }, language }),
        country
    });
    stitcherService.onGlobalStateChange(globalState_1.onGlobalStateChange, true);
    stitcherService.addGlobalUncaughtErrorHandler((e) => {
        var _a;
        if (((_a = e.message) === null || _a === void 0 ? void 0 : _a.indexOf('LOADING_SOURCE_CODE')) > 0) {
            mfe_common_common_utils_lib_1.notificationUtils.fail({
                title: 'System Time Out',
                description: 'Please retry or contact Business Call Centre.',
                description2: 'Please contact our Business Call Centre at 1300 888 828 (Local) / +603 2297 3000 (Overseas) for assistance.',
                isGlobalError: true
            });
            loader(false);
        }
    });
    /**
     * Step4 prepare register apps
     */
    (0, index_logic_1.processMultiLanguageProps)(fullRegisterConfig);
    const apps = (0, mfe_common_stitcher_lib_1.initiateMFEList)({
        apps: registerConfig.subApps,
        publicPath,
        globalProps: {
            language,
            publicPath,
            transactionSigningRender: render_1.TransactionSigningRender,
            changePasswordRender: render_1.ChangePasswordRender
        },
        defaultViewPort: '#app',
        loader
        // To confirm
        // timestamp
    });
    // To confirm
    // const loginActiveRule = apps.find(app => app.alias === 'login')?.activeRule
    // if (isLogin()) {
    // 	await getSystemParameter()
    // }
    (0, render_1.login2faRender)({ language, country });
    if (useMockApi === '1') {
        console.log('stitcher ---> Initializing miragejs');
        (0, server_1.makeMockServer)({ environment: 'development' });
    }
    const getLifeCycles = () => {
        return {
            beforeLoad: [
                (app) => {
                    initPropsInterceptor(app);
                    // import mfe dependency
                    (0, config_1.loadDependencies)(app);
                    //const { account } = stitcherService.getGlobalState()
                    // const { userId } = account
                    console.log('stitcher', stitcherService.getGlobalState());
                    // if (app.configuration.loginRequired) {
                    // 	// do something to achieve access control
                    // 	if (userId === undefined || userId === '') {
                    // 		history.push(welcomeURL)
                    // 		loader(false)
                    // 	}
                    // }
                    return Promise.resolve(app);
                }
            ],
            afterUnmount: [
                (app) => __awaiter(void 0, void 0, void 0, function* () {
                    const { name } = app;
                    initProps[name] = {};
                })
            ],
            beforeMount: [(app) => {
                    mfe_common_common_utils_lib_1.notificationUtils.clear();
                    return Promise.resolve(app);
                }]
        };
    };
    const registerPostLoginSubApps = () => __awaiter(void 0, void 0, void 0, function* () {
        const postLoginSubApps = yield mfe_1.default.getRegisterMFEList(true);
        fullRegisterConfig = Object.assign(Object.assign({}, fullRegisterConfig), postLoginSubApps);
        const loginApps = [
            ...(0, mfe_common_stitcher_lib_1.initiateMFEList)({
                apps: postLoginSubApps.subApps,
                publicPath,
                globalProps: {
                    language,
                    publicPath,
                    transactionSigningRender: render_1.TransactionSigningRender,
                    changePasswordRender: render_1.ChangePasswordRender
                },
                defaultViewPort: '#app',
                loader
            })
        ];
        stitcherService.registerMicroApps(loginApps, {
            globalProps,
            lifeCycles: getLifeCycles()
        });
    });
    // the props that will pass into all subapps
    const globalProps = Object.assign(Object.assign({}, registerConfig.globalProps), { history,
        theme: config_1.theme, getGlobalState: stitcherService.getGlobalState, setGlobalState: stitcherService.setGlobalState, onGlobalStateChange: stitcherService.onGlobalStateChange, updateLanguage: update_language_1.default,
        stitcherLogin2FATrigger: stitcherLogin2faTrigger_1.default,
        stitcherGetLanguageFile: stitcherGetLanguageFileTrigger_1.getLanguageFile,
        getLoginContext: global_1.getLoginContext, getLandingApp: () => {
            const { stitcher } = registerConfig;
            return apps.find(a => a.name === stitcher.landing);
        }, getAppDetails: () => apps, getAppDetailsByName: name => apps.find(app => app.name === name), getLanguageCode: () => language, loader, toggleLoader: show => {
            const showLoader = show || false;
            loader(showLoader);
        }, toggleIdleSessionTimeout: refreshSession => {
            idleSessionTimeout(refreshSession, stitcherService.getGlobalState, stitcherService.setGlobalState);
        }, toggleClearIntervalAndTimeout: () => {
            clearIntervalAndTimeout(stitcherService.getGlobalState);
        }, toggleAutoLogoffDeactivation: (boolean, duration) => {
            let refreshTokenInterval = 0;
            if (duration === undefined || null) {
                refreshTokenInterval = 480000;
            }
            else {
                refreshTokenInterval = duration;
            }
            if (boolean) {
                autoLogOffTimer = setInterval(() => {
                    autoLogoffDeactivation(stitcherService.getGlobalState, stitcherService.setGlobalState);
                }, refreshTokenInterval);
            }
        }, toggleTokenExpired: () => {
            tokenExpired(stitcherService.getGlobalState, stitcherService.setGlobalState);
        }, registerPostLoginSubApps: registerPostLoginSubApps });
    const initProps = {
        stateParamsFrom: {
            name: '',
            stateParams: {}
        }
    };
    apps.forEach(app => {
        initProps[app.name] = {};
    });
    const initPropsInterceptor = app => {
        const { props } = app;
        props.getInitProps = () => {
            console.log('initProps', app.name, initProps);
            return initProps[app.name];
        };
        props.setInitProps = (appName, obj) => {
            initProps[appName] = obj;
            console.log('setInitProps', appName, initProps[appName]);
        };
        props.navigateTo = (urlPath, params) => {
            console.log('navigate to', urlPath);
            window.history.pushState({}, app.name, urlPath);
            if (params && Object.keys(params).length > 0) {
                const stateParams = Object.assign({}, params);
                initProps.stateParamsFrom = {
                    name: app.name,
                    stateParams
                };
            }
        };
        Object.assign(app.props, initProps[app.name]);
    };
    //const loginURL = '/login'
    //const mountInterceptor = app => {
    //	const { pathname } = history.location
    //	checkAuthInterceptor({
    //		registerConfig,
    //		history,
    //		app,
    //		loginURL,
    //		landingApp: globalProps.getLandingApp()
    //	})
    //}
    /**
     * Step4 register your app
     */
    console.log('register app:', apps);
    stitcherService.registerMicroApps(apps, {
        globalProps,
        lifeCycles: getLifeCycles()
    });
    /**
     * Step5 start app
     */
    stitcherService.start({
        prefetch: false,
        singular: false,
        sandbox: true,
        excludeAssetFilter: url => url.indexOf('https://recaptcha.net') !== -1
    });
    /**
     * Step5.1 setup global button click tracking
     */
    document.addEventListener('click', (event) => {
        var _a;
        const target = event.target;
        const button = target.closest('button, [role="button"]');
        if (button) {
            const actionLabel = button.getAttribute('dtActionName') ||
                ((_a = button.innerText) === null || _a === void 0 ? void 0 : _a.trim()) ||
                'unknown button';
            const breadcrumbEl = document.querySelector('[aria-label="breadcrumb"]');
            const rawBreadcrumbText = (breadcrumbEl === null || breadcrumbEl === void 0 ? void 0 : breadcrumbEl.innerText) || '';
            const breadcrumb = rawBreadcrumbText.split(/\r?\n/).join(' > ').trim();
            const breadcrumbAndLabel = breadcrumb ? `${breadcrumb}: ${actionLabel}` : actionLabel;
            (0, dynatrace_1.trackAction)(breadcrumbAndLabel);
        }
    }, true);
    document.addEventListener('notificationRendered', (event) => {
        var _a;
        console.log('listening to notificationRendered', event);
        const notificationDetail = event.detail;
        if (notificationDetail) {
            // Get breadcrumb
            const breadcrumbText = ((_a = document.querySelector('[aria-label="breadcrumb"]')) === null || _a === void 0 ? void 0 : _a.textContent) || '';
            const breadcrumb = breadcrumbText.split(/\r?\n/).join(' > ').trim();
            const breadcrumbAndErrorInfo = `Breadcrumb: ${breadcrumb},  Notification Data: ${JSON.stringify(event === null || event === void 0 ? void 0 : event.detail)}`;
            console.log(breadcrumbAndErrorInfo);
            (0, dynatrace_1.trackAction)(breadcrumbAndErrorInfo);
        }
    }, true);
    document.addEventListener('triggerPreLoginLoader', (event) => {
        const triggerPreLoginLoader = event.detail.value;
        if (triggerPreLoginLoader) {
            return loader(true);
        }
        else {
            return loader(false);
        }
    }, true);
    (0, render_1.globalErrorRender)();
    /**
     * Web Browser Action Handling
     */
    const originalPush = window.history.pushState;
    const originalReplace = window.history.replaceState;
    const shouldLogout = window.sessionStorage.getItem("forceLogoutOnLoad");
    let lastNavSource = "internal";
    let historyIndex = 0;
    window.history.pushState = function (...args) {
        lastNavSource = "internal";
        historyIndex++;
        return originalPush.apply(window.history, args);
    };
    window.history.replaceState = function (...args) {
        lastNavSource = "internal";
        return originalReplace.apply(window.history, args);
    };
    const queryParameters = new URLSearchParams(window.location.search);
    const paramIsSsoReturnSuccess = queryParameters.get('isSsoReturnSuccess');
    const paramIsReturnSuccess = queryParameters.get('isReturnSuccess');
    if (shouldLogout === "true" && paramIsSsoReturnSuccess !== "true" && paramIsReturnSuccess !== "true") {
        window.sessionStorage.removeItem("forceLogoutOnLoad");
        triggerLogout();
    }
    else {
        // ensure flag is cleared and dont trigger forcelogout if coming from SSO
        window.sessionStorage.removeItem("forceLogoutOnLoad");
    }
    function triggerLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            const registerConfig2 = yield mfe_1.default.getFullRegisterMFEList();
            sessionExpired(registerConfig2, stitcherService.getGlobalState, stitcherService.setGlobalState, true);
        });
    }
    if (triggerAutoLogout) {
        window.addEventListener("popstate", () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            historyIndex--;
            if (lastNavSource !== "internal" && historyIndex < 0) {
                window.sessionStorage.setItem("logoutOpaqueToken", (_b = (_a = stitcherService.getGlobalState()) === null || _a === void 0 ? void 0 : _a.sessionData) === null || _b === void 0 ? void 0 : _b.opaqueToken);
                window.sessionStorage.setItem("userId", (_d = (_c = stitcherService.getGlobalState()) === null || _c === void 0 ? void 0 : _c.account) === null || _d === void 0 ? void 0 : _d.userId);
                triggerLogout();
            }
            lastNavSource = "browser";
        }));
    }
    window.addEventListener("beforeunload", () => {
        var _a, _b, _c, _d;
        const LoginContext = window.sessionStorage.getItem("LoginContext");
        if (LoginContext) {
            window.sessionStorage.setItem("forceLogoutOnLoad", "true");
            window.sessionStorage.setItem("logoutOpaqueToken", (_b = (_a = stitcherService.getGlobalState()) === null || _a === void 0 ? void 0 : _a.sessionData) === null || _b === void 0 ? void 0 : _b.opaqueToken);
            window.sessionStorage.setItem("userId", (_d = (_c = stitcherService.getGlobalState()) === null || _c === void 0 ? void 0 : _c.account) === null || _d === void 0 ? void 0 : _d.userId);
        }
    });
}))();
window.loadingSpinner = loader;
